import { render, staticRenderFns } from "./AccountRequestList.vue?vue&type=template&id=63469789&scoped=true&"
import script from "./AccountRequestList.vue?vue&type=script&lang=js&"
export * from "./AccountRequestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63469789",
  null
  
)

export default component.exports